'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = require('./utils/identify');

var _identify3 = _interopRequireDefault(_identify2);

var _traits = require('./traits');

var _getUserPackage = require('./utils/cookie/getUserPackage');

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, _propTypes3.default.string);
/**
 * @param traits
 * @returns Object {} with tracking params
 */
function identifySubscriptionSale() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifySubscriptionSale.displayName + ' method');
    return (0, _identify3.default)((0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()));
}

identifySubscriptionSale.displayName = 'identifySubscriptionSale';

exports.default = identifySubscriptionSale;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/identifySubscriptionSale.js
// module id = 2489
// module chunks = 1